(function () {
  'use strict';

  function initStickyBar() {
    var bar = document.querySelector('[data-kwo-stickybar]');
    var target = document.querySelector('.kwo-pdp-buybox');
    if (!bar || !target) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(target);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(initStickyBar);

  // Delegated on document so these keep working even if a section's DOM
  // gets re-rendered after this script first attaches (Shopify section updates).
  document.addEventListener('click', function (e) {
    var aboutToggle = e.target.closest('[data-kwo-about-toggle]');
    if (aboutToggle) {
      var aboutRoot = aboutToggle.closest('[data-kwo-about]');
      if (aboutRoot) {
        var expanded = aboutRoot.classList.toggle('is-expanded');
        aboutToggle.textContent = expanded
          ? aboutToggle.getAttribute('data-less-label')
          : aboutToggle.getAttribute('data-more-label');
      }
      return;
    }

    var tabBtn = e.target.closest('[data-kwo-tab-btn]');
    if (tabBtn) {
      var tabsRoot = tabBtn.closest('[data-kwo-pdp-tabs]');
      if (tabsRoot) {
        var key = tabBtn.getAttribute('data-kwo-tab-btn');
        tabsRoot.querySelectorAll('[data-kwo-tab-btn]').forEach(function (b) {
          b.classList.toggle('is-active', b === tabBtn);
        });
        tabsRoot.querySelectorAll('[data-kwo-tab-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-kwo-tab-panel') === key);
        });
      }
      return;
    }

    var gotoLink = e.target.closest('[data-kwo-goto-tab]');
    if (gotoLink) {
      e.preventDefault();
      var gotoKey = gotoLink.getAttribute('data-kwo-goto-tab');
      var targetBtn = document.querySelector('[data-kwo-tab-btn="' + gotoKey + '"]');
      if (targetBtn) {
        targetBtn.click();
        var tabsSection = targetBtn.closest('[data-kwo-pdp-tabs]');
        if (tabsSection) tabsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var videoTrigger = e.target.closest('[data-kwo-video-trigger]');
    if (videoTrigger) {
      var tpl = videoTrigger.querySelector('[data-kwo-video-template]');
      if (tpl) {
        videoTrigger.innerHTML = '';
        videoTrigger.appendChild(tpl.content.cloneNode(true));
      }
    }
  });
})();